import { render, staticRenderFns } from "./POIUpload.vue?vue&type=template&id=300c4242&"
import script from "./POIUpload.vue?vue&type=script&lang=js&"
export * from "./POIUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports